<template>
  <div class="adviser-benefit-card-grid">
    <AdviserBenefitCard
      v-for="(card, index) in cards"
      :key="`${card.title}-${index}`"
      v-bind="card"
    />
  </div>
</template>

<script>
  import AdviserBenefitCard from './AdviserBenefitCard.vue';

  // Two cards per row on desktop, one per row under 960px (spec 2.3).
  export default {
    name: 'AdviserBenefitCardGrid',
    components: {
      AdviserBenefitCard,
    },
    props: {
      cards: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../../constants/styles/adviser-pages.scss';

  .adviser-benefit-card-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: $adviser-grid-gutter;
    row-gap: $adviser-grid-row-gap;

    @media only screen and (max-width: $adviser-mobile-breakpoint) {
      grid-template-columns: minmax(0, 1fr);
    }
  }
</style>
